import { render, staticRenderFns } from "./SystemDetailView.vue?vue&type=template&id=4f7e98d4&scoped=true"
import script from "./SystemDetailView.vue?vue&type=script&lang=js"
export * from "./SystemDetailView.vue?vue&type=script&lang=js"
import style0 from "./SystemDetailView.vue?vue&type=style&index=0&id=4f7e98d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e98d4",
  null
  
)

export default component.exports